var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.991,
    height: 15.341,
    viewBox: "0 0 17.991 15.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32340",
    "data-name": "Group 32340",
    transform: "translate(44.601 -483.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M-24.267,485.775l-1.693-1.692-8.662,8.662,1.693,1.693a1.261,1.261,0,0,1,1.782,0,1.261,1.261,0,0,1,0,1.782l1.693,1.693,8.662-8.662-1.693-1.693a1.26,1.26,0,0,1-1.782,0A1.26,1.26,0,0,1-24.267,485.775Z",
    transform: "translate(-6.318)",
    fill: "none",
    stroke: "#606060",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M-35.611,488.343l-.541-.587L-44.1,495.7l1.693,1.693a1.26,1.26,0,0,1,1.782,0,1.26,1.26,0,0,1,0,1.782l1.693,1.693,1.109-1.109",
    transform: "translate(0 -2.448)",
    fill: "none",
    stroke: "#606060",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_567",
    "data-name": "Line 567",
    x1: 0.982,
    y1: 0.982,
    transform: "translate(-30.154 490.58)",
    fill: "none",
    stroke: "#606060",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_568",
    "data-name": "Line 568",
    x1: 0.982,
    y1: 0.982,
    transform: "translate(-31.627 489.106)",
    fill: "none",
    stroke: "#606060",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_569",
    "data-name": "Line 569",
    x1: 0.982,
    y1: 0.982,
    transform: "translate(-33.101 487.633)",
    fill: "none",
    stroke: "#606060",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M-14.554,491.291l-.982-.982",
    transform: "translate(-19.038 -4.15)",
    fill: "none",
    stroke: "#606060",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTicket);
export default __webpack_public_path__ + "static/media/event-ticket.9a90f299077d063b258994278a41a811.svg";
export { ForwardRef as ReactComponent };